import {db} from '../config/firebase';
import moment from 'moment';
// save login user data
const save_user = (user) => {
    return {
        type: "SET_USER",
        data: user
    }
};

// save partner company
const save_company = (company) => {
    delete company['gateway'];
    company.companyId = company.id;
    return {
        type: "SET_COMPANY",
        data: company
    }
};

// save partner company
export const save_adminDemo = (data) => {
    return {
        type: "SET_ADMIN_DEMO",
        data: data
    }
};

export const save_partnerSession = (data) => {
    return {
        type: "SET_PARTNER_SESSION",
        data: data
    }
};

export const saveParentCurrentSession = (data) => {
    return {
        type: "UPDATE_PARENT_SESSION",
        data: data
    }
};

export const close_adminDemo = () => {
    return {
        type: "CLOSE_ADMIN_DEMO"
    }
};

// Company partner reauth
export const reauth_partner = (status) => {
    return {
        type: "SET_REAUTH",
        data: status
    }
};

// update dialog
export const update_dialog = (dialog,dialogType) => {
    return {
        type: "SET_DIALOG",
        data: {dialog,dialogType}
    }
};

// Set CompanyId after parent login
export const setCompanyId = (id) => {
    return {
        type: "SET_COMPANYID",
        data: id
    }
};

// set company domain
export const setCompanyDomain = (event) => {
    return {
        type: "SET_COMPANYDOMAIN",
        data: event
    }
};

// update active chat Id
const update_activechatId = (id) => {
    return {
        type: "UPDATE_CHATID",
        data: id
    }
};

// update chat type
const update_chatType = (type) => {
    return {
        type: "UPDATE_CHAT_TYPE",
        data: type
    }
};

// update parent reservation cart route /booking/companyId/groupId=optional
const update_cart = (responseData) => {
    return {
        type: "UPDATE_CART",
        data: responseData
    }
};

export const update_service_cart = (responseData) => {
    return {
        type: "UPDATE_SERVICE_CART",
        data: responseData
    }
};

// update auth user login status
const update_loginStatus = (status) => {
    return {
        type: "SET_LOGINSTATUS",
        data: status
    }
};

// change language
const change_lang = (lang) => {
    return {
        type: "CHANGE_LANG",
        data: lang
    }
};

// set parent email
const set_pm = (email) => {
    return {
        type: "SET_PM",
        data: email
    }
};

// set parent number
const set_pnum = (num) => {
    return {
        type: "SET_PNUM",
        data: num
    }
};

// remove user data when logout
const remove_user = () => {
    return {
        type: "REMOVE_USER"
    }
};

export const remove_parent_user = () => {
    return {
        type: "REMOVE_PARENT_USER"
    }
};

// save school setting
const save_schoolConfig = (schoolConfig) => {
    return {
        type: "SET_SCHOOL_CONFIG",
        data: schoolConfig
    }
};

// set parent location in booking/renew login page
export const set_parentLocation = (data) => {
    return {
        type: "SET_PARENT_LOCATION",
        data: data
    }
};

// action for company theme setting
const save_companyConfig = (companyConfig) => {
    return {
        type: "SET_COMPANY_CONFIG",
        data: companyConfig
    }
};

// partner company planId
export const getPartnerPlanId = (companyId) => {
    return dispatch => {
        db.ref(`Companies/${companyId}/planId`).on('value',(data)=>{
            const planId = data.val();
            dispatch({
                type: 'SET_PARTNER_PLANID',
                data: planId
            })
        })
    }
};

// get companyFonts
export const getCompanyFonts = (companyId) => {
    return dispatch => {
        if(companyId) {
            db.ref(`TemplateSettings/`).orderByChild('companyId').equalTo(companyId).on('value',(data)=>{
                const templateData = data.val();
                if (templateData && Object.values(templateData)[0] !== null) {
                    const fonts = {arabicFont: Object.values(templateData)?.[0]?.arabicFont || '', englishFont: Object.values(templateData)?.[0]?.englishFont || ''}
                    dispatch({
                        type: 'SET_COMPANY_FONTS',
                        data: fonts
                    })
                }
            })
        }
    }
};

// check for parent active sessions
export const checkParentSessions = (uid) => {
    return dispatch => {
        db.ref(`ParentSessions/${uid}`).on('value',(data)=>{
            const sessions = data.val();
            if (sessions && Object.keys(sessions).length > 1) {
                dispatch({
                    type: 'SET_PARENT_ACTIVE_SESSION',
                    data: false
                })
            }
            else{
                dispatch({
                    type: 'SET_PARENT_ACTIVE_SESSION',
                    data: true
                }) 
            }
        })
    }
};

export const checkCompanyServices = (companyId) => {
    return dispatch => {
        if(companyId) {
            db.ref(`Services`).orderByChild('companyId').equalTo(companyId).on('value',(data)=>{
                const services = data.val();
                const filterServices = services && Object.keys(services).length ? Object.values(services)?.filter(v=> !v.courses && !v.archive) : [];
                dispatch({
                    type: 'SET_PARTNER_TOTAL_SERVICE',
                    data: filterServices.length
                })
            })
        }
    }
};

export const checkCompanyCourses = (companyId) => {
    return dispatch => {
        if(companyId) {
            db.ref(`Courses`).orderByChild('companyId').equalTo(companyId).on('value',(data)=>{
                const courses = data.val();
                const filterCourses = courses && Object.keys(courses).length ? Object.keys(courses).length : 0;
                dispatch({
                    type: 'SET_PARTNER_TOTAL_COURSE',
                    data: filterCourses
                })
            })
        }
    }
};

export const getPartnerPlanExpiry = (companyId) => {
    const currentTime = moment().unix();
    return dispatch => {
        db.ref(`Companies/${companyId}/planExpiryDate`).on('value',(data)=>{
            const planExpiryDate = data.val();
            dispatch({
                type: 'SET_PARTNER_PLAN_EXDATE',
                data: planExpiryDate > currentTime ? false : true
            })
        })
    }
};

export const set_cartId = (id) => {
    return {
        type: "SET_CARTID",
        data: id
    }
};

// get subscription plans
const getPlans = () => {
    return dispatch => {
        db.ref('Config/SubscriptionPlans').on('value',(data)=>{
            const planData = data.val();
            dispatch({
                type: 'SET_PLANS',
                data: planData
            })
        })
    }
}

export const closeUpgradeDialog = (event) => {
    return {
        type: 'SET_PARTNER_PLAN_EXDATE',
        data: event
    };
}

// check if window is iframe or original window
export const setIsIframe = (event) => {
    return {
        type: 'SET_IFRAME',
        data: event
    };
}

// set parent temp info like email and uid used to send with otp code
export const setParentTempInfo = (event) => {
    return {
        type: 'SET_TEMP_PARENT_INFO',
        data: event
    };
}

export const getUserCart = ({companyId,parentId}) => {
    return dispatch => {
        if(parentId && companyId) {
            db.ref('BookingCarts').orderByChild('parentId').equalTo(parentId).on('value',(data)=>{
                var bookingCart = data.val();
                let serviceCartList = [];
                let cartList = [];
                let cartId = '';

                if(bookingCart){
                    for(var i in bookingCart) {
                        if(bookingCart[i].companyId === companyId) {
                            serviceCartList = bookingCart[i]?.['serviceList'] ? bookingCart[i]?.['serviceList'] : [];
                            serviceCartList = Object.values(serviceCartList).filter(function (el) {
                                return el != null;
                            });

                            cartList = bookingCart[i]?.['cartList'] ? bookingCart[i]?.['cartList'] : [];
                            cartList = Object.values(cartList).filter(function (el) {
                                return el != null;
                            });
                            cartId = bookingCart[i]?.id || '';
                            break;
                        }
                    }
                }
                
                dispatch({
                    type: 'UPDATE_CART_DATA',
                    data: {serviceCartList,cartList,cartId}
                })
            })
        }
    }
}

// get message for old message component
const getMessages = (id,parentId) => {
    return dispatch => {
        db.ref('Messages').orderByChild('companyId').equalTo(id).on('value',(data)=>{
            var resData = data.val();
            const messages = [];

            for(var i in resData) {
                if(resData[i].parentId === parentId) {
                    messages.push(resData[i])
                }
            }
            dispatch({
                type: 'UPDATE_MESSAGES',
                data: messages
            })
        })
    }
}

// get subject and curriculums from Categories table in DB
const getSubAndCur = () => {
    return dispatch => {
        db.ref('Categories/').orderByChild('name').equalTo('onlineEdu').on('value',(data)=>{
            var resData = data.val();
            let subjects = [];
            let curriculums = [];

            for(var i in resData) {
                subjects = resData[i].subject
                curriculums = resData[i].curriculum
            }
            dispatch({
                type: 'GET_SUBJECT',
                data: [subjects,curriculums]
            })
        })
    }
}

// Get Object of Partner Member permissions
const getPermission = (id) => {
    return dispatch => {
        db.ref('PartnerTeams/'+id+"/permission").on('value',(data)=>{
            var resData = data.val();

            dispatch({
                type: 'GET_PERMISSION',
                data: resData
            })
        })
    }
}

// get approved status on changed in DB and update
const updateStatus = (id) => {
    return dispatch => {
        db.ref('Companies/'+id+'/approved').on('value',(data)=>{
            let resolve = false;
            var status = data.val();
            resolve = true;
            let obj = {status,resolve}
            dispatch({
                type: 'UPDATE_STATUS',
                data: obj
            })
        })
    }
}

// get school ID orderby companyId
const getSchool = (id) => {
    return dispatch => {
        db.ref('Schools').orderByChild('companyId').equalTo(id).on('value',(data)=>{
            var resData = data.val();
    
            if(resData) {
                dispatch({
                    type: 'SCHOOL_ID',
                    data: Object.keys(resData)[0]
                })
            }
        })
    }
};

// get school data orderby companyld
export const getSchoolData = (id) => {
    return dispatch => {
        db.ref(`Schools`).orderByChild('companyId').equalTo(id).on('value',(data)=>{
            var resData = data.val();
            if(resData && Object.values(resData)[0]) {
                const report = Object.values(resData)[0]['reports'] || [];
                dispatch({
                    type: 'SCHOOL_REPORT_LIST',
                    data: report
                })
            }
        })
    }
}

export const getParentWallet = ({companyId,parentId,currency}) => {
    return dispatch => {
        db.ref(`ParentsWallets/`).orderByChild('parentId').equalTo(parentId).on('value',(data)=>{
            const wallet = data.val();
            let walletList = [];
            if(wallet) {
                for(var i in wallet) {
                    if(wallet[i].companyId === companyId && wallet[i].currency === currency) {
                        walletList.push(wallet[i])
                    }
                };
                if(walletList.length > 0) {
                    dispatch({
                        type: 'SET_PARENT_WALLET',
                        data: walletList[0]
                    })
                }
                else{
                    dispatch({
                        type: 'SET_PARENT_WALLET',
                        data: null
                    })
                }
            }
            else{
                dispatch({
                    type: 'SET_PARENT_WALLET',
                    data: null
                })
            }
        })
    }
}

export {
    save_user,
    remove_user,
    save_company,
    getMessages,
    change_lang,
    getSchool,
    updateStatus,
    getSubAndCur,
    getPermission,
    update_loginStatus,
    set_pm,
    set_pnum,
    save_schoolConfig,
    update_activechatId,
    update_chatType,
    save_companyConfig,
    update_cart,
    getPlans
}